import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  CreateIssueInput,
  createIssueMutation,
  createIssueMutation$data,
} from './__generated__/createIssueMutation.graphql'

type IssueMutationProps = {
  environment: Environment
  input: CreateIssueInput
  onError?: (error: Error) => void
  onCompleted?: (response: createIssueMutation$data) => void
}

export function commitCreateIssueMutation({
  environment,
  input: {title, body, repositoryId, labelIds, milestoneId, assigneeIds, issueTemplate, issueTypeId},
  onError,
  onCompleted,
}: IssueMutationProps) {
  const inputHash: CreateIssueInput = {
    title,
    body,
    repositoryId,
    labelIds,
    milestoneId,
    assigneeIds,
    issueTemplate,
    issueTypeId,
  }

  return commitMutation<createIssueMutation>(environment, {
    mutation: graphql`
      mutation createIssueMutation($input: CreateIssueInput!) @raw_response_type {
        createIssue(input: $input) {
          issue {
            databaseId
            repository {
              databaseId
              id
              name
              owner {
                login
              }
            }
            number
            title
            id
            number
            url
          }
          errors {
            message
          }
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
